import { gql } from '@apollo/client'

import { PRICE_TYPE_FRAGMENT } from './PriceTypeFragment'

export const SUBSCRIPTION_TYPE_FRAGMENT = gql`
  fragment SubscriptionType on SubscriptionType {
    id
    name
    features
    planType
    prices {
      ...PriceType
    }
    description
  }
  ${PRICE_TYPE_FRAGMENT}
`
